import React, { Component } from 'react';
import PropTypes from 'prop-types';
import assign from 'object-assign';
import './reactSelect.css';
import Select from 'react-select';
import { FormGroup } from 'react-bootstrap';
import dropDownP from 'assets/images/drop-down-p.svg';
import dropDownN from 'assets/images/drop-down-n.svg';

const DropdownIndicator = props => {
	return (
		<div>
			{
				props.selectProps.menuIsOpen ? (
					<img alt='' src={dropDownP} />
				) : (
						<img alt='' src={dropDownN} />
					)
			}
		</div>
	);
};
export class AutoCompleteCountry extends Component {
	constructor(props) {
		super(props);
		this.getValue = this.getValue.bind(this);
		this.setValue = this.setValue.bind(this);
		this.clearValue = this.clearValue.bind(this);
		this.state = {
			value: this.props.defaultValue || ''
		}
	}

	getValue = () => {
		return this.state.value;
	};

	setValue = (value) => {
		this.setState({ value });
	};

	clearValue = () => {
		this.setState({ value: '' });
	};

	onChange(option, { action }) {
		switch (action) {
			case 'select-option':
				if (option && option.label !== undefined) {
					const { onChangeEvent = () => { } } = this.props;
					onChangeEvent(option);
					this.setState({
						value: option
					});
				}
				break;
			case 'clear':
				this.clearValue();
				break;
			default:
				break;
		}
	}
	notGetOptionWording(option) {
		return `no result matched "${option.inputValue}"`;
	}

	static getDerivedStateFromProps(nextProps, prevState) {
		let newState = null;
		if (prevState.value && nextProps && nextProps.options) {
			nextProps.options.map((item) => {
				if (item.value && item.value === prevState.value.value) {
					newState = item;
				} else {
					item.options && item.options.map((optionsItem) => {
						if (optionsItem.value && optionsItem.value === prevState.value.value) {
							newState = optionsItem;
						}
						return null;
					});
				}
				return null;
			});
		}
		if (newState) {
			return { value: newState };
		} else {
			return null;
		}
	}

	render() {
		const self = this,
			{
				props,
				state
			} = self,
			{
				options = {},
				styles = {},
				frameStyle = {},
				placeholder,
				id,
				defaultValue = {},
				errorText,
				errorTextStyle,
				isDisabled,
				isSearchable,
				isClearable = false,
				isLoading,
				isRtl
			} = props,
			{
				value
			} = state;
		return (
			<FormGroup
				validationstate={errorText && errorText.length > 0 ? 'error' : null}
				style={frameStyle}
			>
				<Select
					className={`basic-single${errorText ? ' has-error' : ''}`}
					classNamePrefix='select'
					value={value}
					placeholder={placeholder}
					isDisabled={isDisabled}
					isLoading={isLoading}
					isClearable={isClearable}
					isSearchable={isSearchable}
					isRtl={isRtl}
					id={id}
					options={options}
					styles={styles}
					onChange={this.onChange.bind(this)}
					noOptionsMessage={this.notGetOptionWording.bind(this)}
					defaultValue={defaultValue}
					components={{ DropdownIndicator }}
				/>
				<div style={assign({}, { color: '#ff1744', fontSize: '14px', marginTop: '5px' }, errorTextStyle)}>
					{errorText}
				</div>
			</FormGroup>
		);
	}
}

AutoCompleteCountry.propTypes = {
	label: PropTypes.any,
	styles: PropTypes.object
};

export default AutoCompleteCountry;
